import { getParamName } from '../../common';

type SearchParams = Record<string, unknown>;

type TableParams = {
  page?: number;
  pageSize?: number;
  sort?: string;
  search?: string;
} & Record<string, string | number | undefined>;

export const getTableParams = (
  search: SearchParams,
  tableId?: string,
  filterKeys: readonly string[] = []
): TableParams => {
  const filters = Object.fromEntries(
    filterKeys.map((key) => [
      key,
      search[getParamName(key, tableId)] as string | undefined,
    ])
  );

  return {
    page: search[getParamName('page', tableId)] as number | undefined,
    pageSize: search[getParamName('pageSize', tableId)] as number | undefined,
    sort: search[getParamName('sort', tableId)] as string | undefined,
    search: search[getParamName('search', tableId)] as string | undefined,
    ...filters,
  };
};
